<template>
    <div>
        <div class="col-md-4 pt-3 centre_sm_none bg-search">

            <div class="bgBox" :class="listShow ? 'chuan-hide' : 'chuan-show'">
                <p class="search-title1">Company Inquiry</p>
                <div class="search-div1">
                    <input v-on:keyup.enter="serchData" v-model="serchKey" placeholder="Please enter key words"/>
                    <a @click="serchData"></a>
                </div>
                <ul class="search-list">
                    <li>
                        <a @click="putval" value="Anhui Jianghuai Automobile Co., Ltd." class="curs">Anhui Jianghuai Automobile Co., Ltd.</a>
                    </li>
                    <li>
                        <a @click="putval" value="Shenzhen ZDST Smart Security Technology Co., Ltd." class="curs">Shenzhen ZDST Smart Security Technology Co., Ltd.</a>
                    </li>
                    <li>
                        <a @click="putval" value="China Everbright Bank Co., Ltd." class="curs">China Everbright Bank Co., Ltd.</a>
                    </li>
                    <li>
                        <a @click="putval" value="Master Kong Beverage Investment (China) Co., Ltd." class="curs">Master Kong Beverage Investment (China) Co., Ltd.</a>
                    </li>
                    <li>
                        <a @click="putval" value="Evergrande Group Co., Ltd." class="curs">Evergrande Group Co., Ltd.</a>
                    </li>
                </ul>
                <ul class="per-ul clear1">
                    <li>
                        <p class="per-p1">6 million+</p>
                        <p class="per-p2">Blacklists and Redlists</p>
                    </li>
                    <li>
                        <p class="per-p1">60 million+</p>
                        <p class="per-p2">Chinese Enterprises</p>
                    </li>
                    <li>
                        <p class="per-p1">230+</p>
                        <p class="per-p2">Countries and Regions</p>
                    </li>
                    <li>
                        <p class="per-p1">200 million+</p>
                        <p class="per-p2">Overseas Enterprises</p>
                    </li>
                </ul>
            </div>

            <div style="border: 1px solid rgba(0,0,0,0);min-height: 99%" class="chuan-show1" :class="listShow ? 'chuan-show' : 'chuan-hide'">
                <div class="search-top">
                    <a href="javascript:;" @click="serchData"></a>
                    <input v-on:keyup.enter="serchData" v-model="serchKey" placeholder="Please enter key words"/>
                </div>
                <!--<div class="notices-div">7101 notices in total</div>-->
                <div class="row nano video_breviary m-0 information_list wenzlist">

                    <div class="nano-content" id="home_right_list">
                        <ul class="list-unstyled">
                            <li v-for="homeList in homeLists" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">

                                <div class="media-body">
                                    <h5>
                                        <div style="cursor:pointer" @click="changeDetails(homeList['companyId'], homeList['companyName'], homeList['companyName'])" class="f15 text-dark font-weight-bold" :class="{'column_active': homeList['companyId']==id}">{{homeList['companyName']}}</div>
                                    </h5>

                                    <div class="span-dis">
                                        <span class="search-Product">{{homeList['status']}}</span>
                                        <span>Legal Representative: {{homeList['operName']}}</span>
                                        <span>Years of Establishment: {{homeList['startDate']}}</span>
                                        <span>Registered Capital: {{homeList['rawRegistCapi']}}</span>
                                    </div>
                                </div>
                            </li>
                            <p class="text-center" v-if="!loadShow||loading"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                            <div v-if="endShow" class="w-100">
                                <p class="text-center p-2">loading....</p>
                            </div>
                            <div v-if="homeLists.length ==0&&!loading" class="nodata text-center">
                                <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="">
                                <p class="text-center p-2">loading</p>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-md-8 pl-0 mt-3 centre_sm_none d-sm-block d-none">


            <div>
                <div class="nano centre_content charge_hint">
                    <div class="centre_content nano-content p-4" :class="homeLists.length == 0 ? 'chuan_back' : ''">

                        <!--<div v-if="homeLists.length ==0" class="nodata text-center">
                            <img src="./database/images/no_data.png" class="mt100"  alt="">
                            <p class="text-center p-2">loading</p>
                        </div>-->
                        <div v-if="homeLists.length > 0">
                            <div class="main_title main_detials_title" style="border-bottom:none">
                                <h3 class="" id="DetailName">{{homeDetail['baseInfo']['companyName']}}</h3>
                                <p>updateDate:{{homeDetail['baseInfo']['updateDate']}} </p>
                                <div class="clearfix"></div>
                            </div>

                            <div class="main_detials">
                                <div class="main_detials_part main_detials_part2">
                                    <h4 class="main_detials_title">
                                        Basic Information
                                    </h4>
                                    <div class="detials_border">
                                        <div>
                                            <table style="width: 100%;font-size:14px">
                                                <tbody>
                                                <tr>
                                                    <td>Unified Social Credit Code:</td>
                                                    <td>{{homeDetail['baseInfo']['creditcode']}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Operation Status:</td>
                                                    <td>{{homeDetail['baseInfo']['status']}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Legal Person :</td>
                                                    <td>{{homeDetail['baseInfo']['operName']}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Registered Capital:</td>
                                                    <td>{{homeDetail['baseInfo']['rawregistcapi']}}</td>

                                                </tr>
                                                <tr>
                                                    <td>Establishment:</td>
                                                    <td>{{homeDetail['baseInfo']['termstart']}}</td>
                                                </tr>
                                                <tr>
                                                    <td>EconKind:</td>
                                                    <td>{{homeDetail['baseInfo']['econKind']}}</td>

                                                </tr>
                                                <tr>
                                                    <td>Address:</td>
                                                    <td>{{homeDetail['baseInfo']['address']}}</td>

                                                </tr>
                                                </tbody></table>
                                        </div>
                                    </div>
                                </div>
                                <!--<div class="main_detials_part main_detials_part3">
                                    <h4 class="main_detials_title">
                                        Key Persons
                                    </h4>
                                    <div class="detials_border">
                                        <ul class="ul-sty">
                                            &lt;!&ndash;<li v-for="staff in homeDetail['staffList']"><p>{{staff['Name']}}</p><p>({{staff['name_cn']}})</p><span>{{homeDetail['transArr'][staff['Job']]}}</span></li>&ndash;&gt;
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>-->
                                <div class="main_detials_part main_detials_part4 main_detials_parts">
                                    <h4 class="main_detials_title">
                                        Information about Shareholders
                                    </h4>
                                    <div v-if="homeDetail['partnerInfoData']['partners'].length > 0" class="detials_border">
                                        <table style="width: 100%" class="infor-tab tab-sty2" border="0" cellspacing="1" cellpadding="0">
                                            <tbody>
                                            <tr><th>Shareholders</th><th>Date</th><th>Amount</th><th>Percent</th><th>Type</th></tr>
                                            <tr v-for="holder in homeDetail['partnerInfoData']['partners']">
                                                <td>{{holder['stockName']}}</td>
                                                <td>{{holder['realCapiDate']}}</td>
                                                <td>CNY ￥{{holder['shouldCapi']}}</td>
                                                <td>{{holder['stockPercent']}}</td>
                                                <td>{{holder['identifyType']}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="detials_border">
                                        <p class="no_data">No Data.</p>
                                        <ul>
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="main_detials_part main_detials_part5 main_detials_parts">
                                    <h4 class="main_detials_title">
                                        Investment Information
                                    </h4>
                                    <div v-if="homeDetail['investInfoData']['invests'].length > 0" class="detials_border">
                                        <table style="width: 100%" class="tab-sty1" border="0" cellspacing="1" cellpadding="0">
                                            <tbody>
                                            <tr>
                                                <th width="205">Enterprise Name</th><th>Legal Person</th><th>Registered Capital</th><th>Amount</th><th>Percent</th>
                                                <th>Registration Date</th><th>Operation Status</th>
                                            </tr>
                                            <tr v-for="invest in homeDetail['investInfoData']['invests']">
                                                <td>{{invest['name']}}</td>
                                                <td>{{invest['operName']}}</td>
                                                <td><div>CNY</div>￥{{invest['registCapi']}}</td>
                                                <td></td>
                                                <td></td>
                                                <td>{{invest['startDate']}}</td>
                                                <td></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="detials_border">
                                        <p class="no_data">No Data.</p>
                                        <ul>
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="main_detials_part main_detials_part6 main_detials_parts">
                                    <h4 class="main_detials_title">
                                        Case Information
                                    </h4>
                                    <div v-if="homeDetail['caseInfoData']['cases'].length > 0" class="detials_border">
                                        <table style="width: 100%" class="tab-sty2" border="0" cellspacing="1" cellpadding="0">
                                            <tbody>
                                            <tr><th style="width: 88px">Judge Date</th><th>Case No</th><th>Case Name</th><th>Court</th></tr>
                                            <tr v-for="cases in homeDetail['caseInfoData']['cases']">
                                                <td>{{cases['judgeDate']}}</td>
                                                <td>{{cases['caseNo']}}</td>
                                                <td>{{cases['caseName']}}</td>
                                                <td>{{cases['court']}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="detials_border">
                                        <p class="no_data">No Data.</p>
                                        <ul>
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="main_detials_part main_detials_part6 main_detials_parts">
                                    <h4 class="main_detials_title">
                                        Changes in Industrial and Commercial Registration
                                    </h4>
                                    <div v-if="homeDetail['changeInfoData']['changes'].length > 0" class="detials_border">
                                        <table style="width: 100%" class="tab-sty2" border="0" cellspacing="1" cellpadding="0">
                                            <tbody>
                                            <tr><th style="width: 88px">Date</th><th>Item</th><th>Original registration item</th><th>Item of modification registration</th></tr>
                                            <tr v-for="changes in homeDetail['changeInfoData']['changes']">
                                                <td>{{changes['changeDate']}}</td>
                                                <td>{{changes['changeName']}}</td>
                                                <td>{{changes['beforeChange']}}</td>
                                                <td>{{changes['afterChange']}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="detials_border">
                                        <p class="no_data">No Data.</p>
                                        <ul>
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <!--<div class="main_detials_part main_detials_part6 main_detials_parts">
                                    <h4 class="main_detials_title">
                                        Changes in Industrial and Commercial Registration
                                    </h4>
                                    <div v-if="homeDetail['changeList'].length > 0" class="detials_border">
                                        <table style="width: 100%">
                                            <tbody>
                                            <tr><th>Date</th><th>Item</th><th>Original registration item</th><th>Item of modification registration</th></tr>
                                            <tr v-for="change in homeDetail['changeList']">
                                                <td>{{change['ChangeDate']}}</td>
                                                <td>{{homeDetail['transArr'][change['ProjectName']]}}</td>
                                                <td class="click_detials">{{homeDetail['transArr'][change['BeforeContent']]}}</td>
                                                <td class="click_detials">{{homeDetail['transArr'][change['AfterContent']]}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="detials_border">
                                        <p class="no_data">No Data.</p>
                                        <ul>
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>-->
                                <!-- <div class="main_detials_part main_detials_partN">
                                    <h4 class="main_detials_title">
                                        Annual Report
                                    </h4>
                                    <div class="detials_border">
                                        <p class="no_data">No Data.</p>
                                        <ul>
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div>
                                </div> -->
                                <div class="main_detials_part main_detials_part7 main_detials_parts">
                                    <h4 class="main_detials_title">
                                        Branches
                                    </h4>
                                    <div v-if="homeDetail['branchInfoData']['branchs'].length > 0" class="detials_border">
                                        <table style="width: 100%" class="tab-sty2" border="0" cellspacing="1" cellpadding="0">
                                            <tbody>
                                            <tr>
                                                <th>Enterprise Name</th><th>Registered No</th></tr>
                                            <tr v-for="branch in homeDetail['branchInfoData']['branchs']">
                                                <td>{{branch['name']}}</td>
                                                <td>{{branch['regNo']}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="detials_border">
                                        <p class="no_data">No Data.</p>
                                        <ul>
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div>
                                    <!-- <div class="detials_border">
                                        <p class="no_data">No Data.</p>
                                        <ul>
                                        </ul>
                                        <div class="clearfix"></div>
                                    </div> -->
                                </div>
                                <!-- <div class="main_detials_part main_detials_part8 main_detials_parts">
                                    <h4 class="main_detials_title">
                                        Related News
                                    </h4>
                                    <div class="detials_border" id="RelationNews">
                                        <p class="no_data">No Data.</p>
                                        <table>
                                        </table>
                                    </div>
                                </div> -->
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div >
    </div>
</template>
<script>
    export default({
        name: 'credits',

        data: function() {
            return {
                searchData:{},
                serchKey:'',
                homeLists: [],
                loadShow:true,
                page:1,
                total_page:1,
                homeDetail:[],
                id:0,
                name:'',
                enname:'',
                endShow:false,
                listShow:false,
                loading:false

            }
        },
        created: function() {

        },

        mounted() {
            document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
            this.load();
        },
        methods: {
            serchData(){
                var that = this;
                that.listShow = true;
                that.loading = true;
                that.homeLists = [];
                that.$axios.post('/api/pc/getlist',{
                    keywords:that.serchKey,
                    page:1
                }).then(function(data) {
                    if(data.data.state){
                        that.loadShow=true;
                        that.endShow=false;
                        that.homeLists = data.data.data;
                        that.total_page = data.data.total_page;
                        that.page = 1;
                        if(that.homeLists.length>6){
                            that.loadShow = false;
                        }
                        if(that.homeLists.length>0){
                            var self = that;
                            self.id = self.homeLists[0]['companyId'];
                            self.name = self.homeLists[0]['companyName'];
                            self.enname = self.homeLists[0]['companyName'];
                            self.listShow = true;
                            self.getHomeDetails();
                        }
                        that.loading = false;
                    }else{
                        that.loading = false;
                        // console.log(data.data.error);
                    }
                })
            },
            putval(){
                var that = this;
                var val = event.target.getAttribute("value");
                that.serchKey=val;
                that.serchData();
            },
            handleScroll() {
                var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_right_list').scrollHeight; // 总高度
                if(((all - 20) < (top + client)) && !this.loadShow) {
                    this.page++;
                    if(this.page > this.total_page) {
                        this.endShow = true;
                        return;
                    }
                    this.loadShow = true;
                    var that = this;
                    that.$axios.post('/api/pc/getlist',{
                        keywords:that.serchKey,
                        page:that.page
                    }).then(function(data) {
                        var homeListes = data.data.data;
                        var new_homeLists = that.homeLists.concat(homeListes);
                        that.homeLists = new_homeLists;
                        that.loadShow = false;
                    })
                    /*that.$axios({
                        url: 'https://api.imsilkroad.com/encomp/search/20/'+that.page+'/'+encodeURI(that.serchKey),
                        method: 'get',
                        headers: {
                            token: 'e7e5272ff1f36623a5532e5e949b26ea'
                        }

                    }).then(function(data) {
                    }, function(response) {

                    })*/

                }

            },
            getHomeDetails(){
                var self = this;
                self.$axios.post('/api/pc/getdetail',{
                    id:self.id,
                    name:self.name
                }).then(function(datas) {
                    self.homeDetail = datas.data.data;
                    self.homeDetail.enname = self.enname;
                })
            },
            changeDetails(id, name, enname){
                this.id = id;
                this.name = name;
                this.enname = enname;
                this.getHomeDetails();
            },
            reset(){
                this.serchKey='';
                this.serchData();
            }
        },
        computed: {

        },
        watch: {
            homeDetail:{
                handler(val, oldVal){

                },
                deep: true
            }
        },
        components: {

        }
    })
</script>
<style scoped type="text/css">
    .nano > .nano-contents{
        position:relative;
        max-height:440px;
        margin: auto!important;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
    .main_detials_title {
        border: none;
    }
    .main_title {
        width: 100%;
        /* height: 100px; */
        color: #343a40;
        padding: 0 20px;
        border-bottom: 1px solid #343a40;
    }
    .main_title h3 {
        float: left;
        line-height: 60px;
        letter-spacing: 1px;
        font-size: 24px;
        font-weight: bold;
    }
    .main_title p {
        display: inline-block;
        float: right;
        padding-top: 25px;
    }
    .main_detials .main_detials_part {
        color: #000;
        margin-bottom: 20px;
    }
    .main_detials .main_detials_part .detials_border {
        border: 1px solid #ccc;
        border-radius: 5px;
    }
    .main_detials .main_detials_part1 h4 {
        height: 40px;
        line-height: 40px;
        margin: 10px 0;
        border: none;
        font-size: 18px;
    }
    .main_detials .main_detials_part h4 {
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        text-indent: 1em;
        letter-spacing: 1px;
        color: #0089d1;
    }
    /* .main_detials .main_detials_title:before{
        content: "";
        margin-right: .14rem;
        display: table;
        width: .12rem;
        height: .12rem;
        background: #1c71b7;
        border-radius: 50%;
    } */
    .main_detials .main_detials_part .main_detials_n {
        color: #6a6a6a;
    }
    .main_detials .main_detials_part .main_detials_m {
        font-weight: 700;
    }
    .main_detials .main_detials_part table {
        width: 1160px;
        margin: 0 auto;
        line-height: 24px;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    table {
        max-width: 100%;
        background-color: transparent;
    }
    tbody {
        display: table-row-group;
        vertical-align: middle;
        border-color: inherit;
    }
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
    }
    .main_detials .main_detials_part1 table td {
        vertical-align: top;
    }
    .main_detials .main_detials_part table td {
        padding: 8px 5px;
    }
    .main_detials .main_detials_part2 p {
        text-indent: 1.5em;
        font-weight: 700;
        height: 40px;
        line-height: 40px;
        padding: 0;
        margin: 0;
    }
    .main_detials .main_detials_part3 li {
        float: left;
        width: 160px;
        margin: 20px 0 20px 35px;
        padding: 5px;
        text-align: center;
        border: 1px solid #343a40;
        border-radius: 5px;
    }
    .main_detials .main_detials_part3 li p:nth-child(1) {
        font-weight: 700;
    }
    .main_detials .main_detials_part3 li p {
        padding: 0;
        margin: 0;
        letter-spacing: 1px;
    }
    .main_detials .main_detials_part3 li p:nth-child(2) {
        color: #6a6a6a;
    }
    .main_detials .main_detials_part .no_data {
        margin: 0 auto;
        text-align: center;
        line-height: 40px;
    }
    .tab-sty tr td:nth-child(1){
        text-align:right;
    }
    .ul-sty>li{
        height: 205px;
    }
    .infor-tab td{
        /* padding:0 !important; */
    }
    .tab-sty1 th,.tab-sty2 th{
        font-weight: bold;
        text-align: center;
    }
    .tab-sty1 td,.tab-sty1 th{
        border:1px solid #ccc
    }
    .tab-sty1 tr:nth-child(1) th{
        border-top: none;
    }
    .tab-sty1 tr td:first-child,.tab-sty1 tr th:first-child{
        border-left: none;
        padding-left:20px;
    }
    .tab-sty2 td,.tab-sty2 th{
        border-top:1px solid #ccc
    }
    .tab-sty2 tr:nth-child(1) th{
        border-top: none;
    }
    #right_content_title_information{
        padding-left: 10px !important;
        font-size:30px;
        font-weight:normal;
        border-bottom:none;
        text-align:center;
        padding-bottom:34px;
        color:rgba(255,255,255,1);
        line-height:34px;
        padding-top: 24px;
    }
    .span-dis span{
        color: #767676;
        display:block;
    }
    .right_list_content{
    }
    .search-box-sty{
        height:40px;
        position: relative;
    }
    .search-box-sty input{
        height:40px;
    }
    .search-icon{
        position:absolute;
        right:0;
        top:0;
        width:106px;
        height:40px;
        display:block;
        background: url("/database/images/xinmem/search-btn.png") no-repeat center left 20px;
        background-size:19px auto;
        background-color:rgba(253,169,42,1);
        border-radius:0px 3px 3px 0px;
        color:#fff !important;
        font-size:12px;
        padding-left:46px;
        line-height: 40px;
        cursor: pointer;
    }
    .media-body h5,.span-dis span{
        color: #fff !important;
    }
    .text-dark{
        color: #000 !important;
    }
    .column_active{
        color: #208eff !important;
        background: #f3f4f4 !important;
    }
    .chuan_back{
        background: url("/database/images/xinmem/back.png") no-repeat center !important;
        background-size:333px auto !important;
        background-color:#f2f3f4 !important;
    }

    /*新样式*/
    body,html{
        height: 100%;
    }
    .bgBox{
        width: 100%;
        min-height: 100%;
        background: url("/database/images/xinmem/bg_home.cac32.jpg") no-repeat 50%;
        background-size: cover;
        padding: 40px 20px;
    }
    .search-title1{
        font-size: 24px;
        color: #fff;
    }
    .search-div1{
        background: #fff;
        margin-top: 40px;
        height: 44px;
        border-radius: 8px;
        position: relative;
    }
    .search-div1 input{
        display: block;
        border-radius: 8px;
        width: 100%;
        height: 100%;
        padding: 0 10px;
        border: none;
    }
    *{
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    .search-div1 a{
        position: absolute;
        right: 15px;
        width: 20px;
        height: 44px;
        top:0;
        cursor: pointer;
        background: url("/database/images/xinmem/search-btn.png") no-repeat center;
        background-size: 100% auto;
    }
    .search-list{
        padding-top: 20px;
    }
    .search-list li a{
        background: #000;
    /*    overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;*/
        padding: 5px 10px;
        border-radius: 24px;
        color: #fff;
        opacity: 0.4;
        cursor: pointer;
        display: block;
        margin-top: 6px;
        font-size: 12px;
    }
    /*  .per-ul{
          padding-top: 20px;
      }*/
    .per-ul li{
        width: 50%;
        float: left;
        margin-top: 25px;
        padding-right: 10px;
    }
    /*清浮动*/
    .clear1::after{
        display: block;
        clear: both;
        content: "";
    }
    .per-p1{
        font-size: 20px;
        color: #fff;
    }
    ul li{
        list-style: none;
    }
    .per-p2{
        font-size: 10px;
        margin-top: 5px;
        color: hsla(0,0%,100%,.7);
    }
    .chuan-show{
        display: block;
    }
    .chuan-hide{
        display: none;
    }
    /*列表样式*/
    .search-top{
        margin: 20px 20px 0;
        position: relative;
        height: 44px;
    }
    .search-top input{
        display: block;
        width: 100%;
        border: 2px solid rgb(238, 238, 238);
        background: #fff;
        padding-left: 44px;
        height: 100%;
        border-radius: 44px;
    }
    .search-top a{
        background: url("/database/images/xinmem/searchCCC.png") no-repeat center;
        background-size: 100% auto;
        width: 20px;
        height: 44px;
        display: block;
        position: absolute;
        top: 0;
        left: 13px;
    }
    .search-Result{
        white-space: nowrap;
        padding: 0 10px;
        height: 44px;
        overflow: scroll;
    }
    .search-Result::-webkit-scrollbar{
        display: none;
    }
    .search-Result li{
        display: inline-block;
        margin-right: 30px;
        line-height: 44px;
        position: relative;
    }
    input,textarea,button{
        outline:none;
    }
    .search-Result li a{
        font-size: 14px;
        cursor: pointer;
    }
    .search-Result .search-Result-li::after{
        background-color: #1c71b7;
        width: 40px;
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -o-transform: translateX(-50%);
    }
    .notices-div{
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
        color: #999;
        font-size: 12px;
        background-color: #f6f6f6;
    }
    .icon-enterprise{
        color: #1c71b7;
        float: left;
        margin-right: 10px;
    }
    .search-ul{
        padding: 0 15px;
    }
    .search-ul li{
        padding: 15px 0;
        border-bottom: 1px solid #f6f6f6;
    }
    .search-Result-p{
        font-weight: 600;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .Subsist-div{
        color: #333;
        font-size: 14px;
        margin-top: 5px;
    }
    .search-Legal{
        color: #666;
        margin-top: 5px;
        font-size: 14px;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .icon-time,.icon-cash{
        color: #999;
    }
    .search-time{
        margin-top: 5px;
        font-size: 12px;
    }
    .search-time>div{
        margin-right: 15px;
    }
    .search-Product{
        margin-top: 5px;
        color: #666;
        font-size: 12px;
    }
    .curs{
        cursor: pointer;
    }
    .chuan-show1{
        background: #fff !important;
    }
    .media-body h5[data-v-6de697f4], .span-dis span[data-v-6de697f4], .text-dark[data-v-6de697f4]{
        color: #666 !important;
    }
    .text-dark{
        font-weight: 600 !important;
        font-size: 14px !important;
    }
    .span-dis>span+span{
        margin-top: 5px;
    }
    .span-dis>span+span{
        margin-top: 5px;
    }
    .border-bottom{
        border: none !important;
    }
    .list-unstyled>li::before{
        width: auto !important;
        left: 20px !important;
        right: 20px !important;
    }
    body .span-dis span{
        color: #666 !important;
    }
    .search-Product{
        margin-top: 5px !important;
        color: #666 !important;
        font-size: 12px !important;
    }
    .search-list>li{
        margin-top: 5px;
    }
    .search-list li a:hover{
        color: #fff !important;
    }
</style>
